const id = document.getElementById("lightgallery")
lightGallery(id, {
    selector: ".our-works_item "
})